'use client';

import { cn } from '@utils';
import type { RichTextSectionStoryblok } from '@utils/storyblok/storyblok';
import { storyblokEditable } from '@utils/storyblok/storyblokEditable';
import { Heading } from '@common/typography/Heading';
import { RichText } from '@common/typography/RichText';

export function RichTextSection({
  title,
  content,
  backgroundColor = 'light',
  maxWidth = 'medium',
  ...blokProps
}: RichTextSectionStoryblok) {
  const getBgClass = () => {
    switch (backgroundColor) {
      case 'light':
        return 'bg-white';
      case 'muted':
        return 'bg-muted';
      case 'accent':
        return 'bg-secondary/10';
      default:
        return 'bg-white';
    }
  };

  const getMaxWidthClass = () => {
    switch (maxWidth) {
      case 'narrow':
        return 'max-w-2xl';
      case 'medium':
        return 'max-w-4xl';
      case 'wide':
        return 'max-w-6xl';
      case 'full':
        return 'max-w-full';
      default:
        return 'max-w-4xl';
    }
  };

  return (
    <section
      {...storyblokEditable(blokProps)}
      // text-accent resets any cascaded text-light coming from a parent Section
      className={cn('py-16 md:py-24 text-accent', getBgClass())}
    >
      <div className={cn('container', getMaxWidthClass())}>
        {title && (
          <Heading
            className="text-accent mb-8"
            variant="h2"
          >
            {title}
          </Heading>
        )}

        {content && (
          <RichText
            className="text-lg text-primary prose prose-lg max-w-none"
            content={content}
          />
        )}
      </div>
    </section>
  );
}
